import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
//import { actionCreators } from '../store/WeatherForecasts';
import { actionCreators } from '../store/actions/dataActions';
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";
import Select from 'react-select';
import EasyEdit, { Types } from "react-easy-edit";
import Editable from "react-x-editable";
import { Tab, Row, Nav, Col, Card, Spinner, CardDeck, OverlayTrigger, Popover } from 'react-bootstrap';

class ListShortLists extends Component {

    constructor(props) {
        super(props);

        this.state = {
           
            _mapSelected: 'summary',
            data: null,
            filtered: []
            
            
        };

    }
    componentDidMount() {
        // This method is called when the component is first added to the document

        this.ensureDataFetched();

    }

    componentDidUpdate() {
        // This method is called when the route parameters change
        this.ensureDataFetched();
    }

    ensureDataFetched() {
     //   const shortlistID = this.props.match.params.shortlistID;
        // this.props.requestWeatherForecasts(startDateIndex);
   //     this.props.getShortList(shortlistID);
        this.props.requestShortList(false, "");
        this.props.requestShortList(true, "");

    }

    reorder(list, startIndex, endIndex) {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    moveSingleTrack(e) {
        var asset = this.props.tempShortList.filter(t => t.code == e.dataTransfer.getData("text"));
        if (asset != null) {
            this.props.AddSingeAssetToShortList(asset[0]);
        }
    }

    selectTrack(e) {

      //  var track = this.props.assetSearchList.filter(a => a.code == e.target.value);
        this.props.selectTrack(e.target.value);
    }

    goUp(data) {

        let index;
        if (data.target) {
            index = parseInt(data.target.value);
        } else {
            index = parseInt(data);
        }


        let items = this.reorder(
            this.props.tempShortList,
            index,
            index == 0 ? 0 : index - 1
        );
        console.info(items);

        this.props.sortTempTracks(items);
      //  this.props.updateShortList();
    }

    goDown(data) {

        let index;

        if (data.target) {
            index = parseInt(data.target.value);
        } else {
            index = parseInt(data);
        }

        let items = this.reorder(
            this.props.tempShortList,
            index,
            index === this.props.tempShortList.length - 1 ? index : index + 1
        );
        console.info(items);

        this.props.sortTempTracks((items));
        //this.props.updateShortList();
    }

    onDragStart(e, id) {
        console.info(e + id);
        e.dataTransfer.setData("text", id);
    }

    onDragEnd(result) {
        console.info(result);
        if (!result.destination) {
            console.info("houston");
            return;
        }

        console.info(result.source.index);
        console.info(result.destination.index);
        let items = this.reorder(
            this.props.tempShortList,
            result.source.index,
            result.destination.index == -1 ? 0 : result.destination.index
        );
        console.info(items);

        this.props.sortTempTracks(items);
       // this.props.updateShortList();

    }

    onNameChange(e) {
        this.props.SetShortlistName(e.target.value);
    }

    renderShortListItems() {
        let data;

        if (this.props.shortlistDetail != null) {
            data = this.props.shortlistDetail.assets;
        }
       



        return <table onDragOver={(e) => e.preventDefault()} onDrop={(e) => this.moveSingleTrack(e)} className='table table-hover search'>
            <thead>
                <tr>
                    <th>#</th>
                    <th>ISRC</th>
                    <th>Audio</th>
                    <th>Catalog</th>
                    <th>Name</th>
                    <th>Artist</th>
                    <th>Genre</th>
                    <th>Sub Genre</th>
                                  
                </tr>
            </thead>
            <tbody>
                {
                    this.props.shortlistDetail ? data.map((product, index) =>
                        <tr key={product.code}>
                            <td>{index + 1}</td>
                            <td>{product.isrc}</td>
                            <td> <button onClick={() => this.props.setAudioUrl(product.fugaID)}> {this.props.audioURL === product.fugaID ? "Playing" : "Play"}</button> </td>
                            <td>{product.catalog}</td>
                            <td>{product.name}</td>
                            <td>{product.displayArtist}</td>
                            <td>{product.genre}</td>
                            <td>{product.subGenre}</td>      

                        </tr>
                    )
                        : []}

            </tbody>
        </table>;
    }
    renderForecastsTable() {
        let data;
        data = this.props.tempShortList;
        return <table className='table table-hover search'>
            <thead>
                <tr>
                    <th>#</th>
                    <th>ISRC</th>
                    <th>Catalog</th>
                    <th>Name</th>
                    <th>Artist</th>
                    <th>Genre</th>
                    <th>Sub Genre</th>
                    <th>Audio</th>                   
                    <th>version</th>                   
                    <th>LoP</th>                   
                    <th>Use</th>
                    <th></th>
                    <th></th>
                    <th>Short Listed</th>
                </tr>
            </thead>
            <tbody>
                {
                    !this.props.isLoadingSearchList ? data.map((product, index) =>
                        <tr draggable onDragStart={(e) => this.onDragStart(e, product.isrc)} onDragEnd={(e) => this.onDragEnd(e, product.isr)} onDragOver = {(e) => e.preventDefault()} key={product.isrc}>
                            <td>{index+1}</td>
                            <td>{product.isrc}</td>
                            <td>{product.catalog}</td>
                            <td>{product.name}</td>
                            <td>{product.displayArtist}</td>
                            <td>{product.genre}</td>
                            <td>{product.subGenre}</td>
                            <td> <button onClick={() => this.props.setAudioUrl(product.fugaID)}> {this.props.audioURL === product.fugaID ? "Playing" : "Play"}</button> </td>                          
                            <td>{product.version}</td>                          
                            <td>{product.lop == "ZXX" ? "Ins" : product.lop}</td>                         
                            <td>{product.productCount == 0 ? "Inactive" : product.productCount < 5 ? "Active" : "Hyper"}</td>
                            <td><span className='glyphicon glyphicon-arrow-up' value={index} onClick={() => this.goUp(index)} >up</span></td>
                            <td><span className='glyphicon glyphicon-arrow-down' value={index} onClick={() => this.goDown(index)}>down</span></td>
                            <td><button className='btn btn-default' value={product.isrc} onClick={this.selectTrack.bind(this)}> {this.props.tempShortList.filter(t => t.isrc === product.isrc).length > 0 ? '√' : 'X'} </button></td>

                        </tr>
                    )
                        : []}

            </tbody>
        </table>;
    }

    createShortList(e) {
        this.props.CreateShortList();
    }

    selectAndShow(data) {
       
        this.props.SetShortlist(data,false);
        if (data !== null) {
            this.props.requestShortListDetailDraft(false);
            this.props.requestShortListAnalysis();
        } else {
            this.props.ClearShortListDetail();
        }

    }

     renderShortlistAnalysis() {
        var catalog = this.props.shortlistAnalysis;
        const toHHMMSS = (secs) => {
            var sec_num = parseInt(secs, 10)
            var hours = Math.floor(sec_num / 3600) % 24
            var minutes = Math.floor(sec_num / 60) % 60
            var seconds = sec_num % 60
            return [hours, minutes, seconds]
                .map(v => v < 10 ? "0" + v : v)
                .filter((v, i) => v !== "00" || i > 0)
                .join(":")
        }
        if (this.props.isLoadingShortListAnalysis) {
            return <div>Loading...</div>
        } else {
            return (<dl className="dl-horizontal">
                <dt>Number of tracks</dt>
                <dd>{catalog.numberTracks}</dd>
                <dt>Tracks duration</dt>
                <dd>{toHHMMSS(catalog.totalDuration)}</dd>
                <dt>Public Domain</dt>
                <dd>{catalog.pd ? 'Yes' : 'No'}</dd>
                <dt>Type of Product</dt>
                <dd>{catalog.typeOfProduct}</dd>
                <dt>Similar Products (40% or more similar)</dt>
                <dd>{catalog.productsWithSimilarTracks}</dd>
                <dt>Note</dt>
                <dd>{catalog.warning}</dd>
            </dl>)
        }
    }

   

    modifyShortList() {
        this.props.ModifyShortList();

    }

    setReady() {
        this.props.setListReady(this.props.selectedShortlist, "ready");

    }

    setDelete() {
        this.props.setListDelete();
    }


    setListname(id, name) {
      
        this.props.setListName(id, name.newValue);

    }

    onFilteredChangeCustom = (value, accessor) => {
        let filtered = this.state.filtered;//this.props.filtered;
        let insertNewFilter = 1;



        if (filtered.length) {
            filtered.forEach((filter, i) => {
                if (filter["id"] === accessor) {
                    if (value === "" || value === null) filtered.splice(i, 1);
                    else filter["value"] = value;
                    insertNewFilter = 0;
                }
            });
        }

        if (insertNewFilter) {
            filtered.push({ id: accessor, value: value });
        }




        //this.props.setCatalogueFilter(filtered);
        this.setState({ filtered: filtered });
    };
    

    renderReactTable(data, props, main) {
        const save = (value, row) => { this.setListname(row, value); }
       
    //console.info(main.state.filtered);
    const onRowClick = (state, rowInfo, column, instance) => {
        if (typeof rowInfo !== "undefined") {
            return {

                style: {
                    background: rowInfo.original._id === props.selectedShortlist ? '#00afec' : 'white',
                    color: rowInfo.original._id === props.selectedShortlist ? 'white' : 'black',

                }
            }
        } else {
            return {
                onClick: (e, handleOriginal) => {
                    if (handleOriginal) {
                        handleOriginal()
                    }
                }
            }
        }
    }
    return (
        <ReactTable
            getTrProps={onRowClick}
            data={data}
            filterable
            filtered={main.state.filtered}        
            onFilteredChange={(filtered, column, value) => {
                main.onFilteredChangeCustom(value, column.id || column.accessor);
            }}

            defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;
                if (typeof filter.value === "object") {
                    return row[id] !== undefined || row[id] !== null
                        ? filter.value.indexOf(row[id]) > -1
                        : true;
                } else {
                    return row[id] !== undefined
                        ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        : true;
                }
            }}


            columns={[
                {                    
                    columns: [
                        {
                           
                            accessor: "_id",
                            Cell: row => (<div>
                                <button style={{ cursor: 'pointer' , "margin-right": "5px"}} onClick={() => this.selectAndShow(row.value)} >select</button >
                                <button style={{ "margin-right": "5px" }} disabled={props.selectedShortlist === row.value ? false : true} onClick={() => this.modifyShortList()}>Edit Tracks</button>
                                <button style={{ "margin-right": "5px" }} disabled={props.selectedShortlist === row.value ? false : true} onClick={() => this.setReady()}>Ready</button>
                                <button style={{ "margin-right": "5px" }} disabled={props.selectedShortlist === row.value ? false : true} onClick={() => this.setDelete()}>Delete</button> </div>),
                        Filter: ({ filter, onChange }) => {
                            return ("")
                        }
                        },
                        {
                            Header: "Title",
                            accessor: "name",
                            Cell: c => (<div>

                                <Editable
                                    handleSubmit={(t) => save(t, c.row._id)}
                                    name="name"
                                    dataType="text"
                                    mode="inline"
                                    title="Change title"
                                    value={c.row.name}
                                    placement="right"
                                    showButtons={true}
                                    disabled={props.selectedShortlist === c.row._id ? false : true}
                                />
                           </div>)
                        },                        
                        {
                            Header: "State",
                            accessor: "validationState"
                        },
                       
                        


                    ]
                }
            ]}
            defaultSorted={[
                {
                    id: "name",
                    desc: true
                }
            ]}
            defaultPageSize={5}
            style={{
              //  height: "450px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight"
        />)
};

    render() {
        const access = localStorage.getItem("accessToken");
      
        let url = this.props ? this.props.audioURL : '';
        return (
            <div>
                <h1>Products</h1>
        


                    <div className="row">
                        <div className="col-sm-9">
                            {this.props.shortLists != null ? this.renderReactTable(this.props.shortLists, this.props, this) : "Loading"}
                        </div>
                    <div className="col-sm-3">{this.props.shortlistAnalysis != null ? this.renderShortlistAnalysis() : 'no data'}</div>
                   
                    <div className="col-sm-12">                     

                       
                        { this.renderShortListItems()}
                      
                            </div>
                        
                        </div>
               
                
               
              
               
            </div>
              
        );
    }




}








export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(ListShortLists);



// WEBPACK FOOTER //
// ./src/components/ListShortLists.js